import { useState } from 'react';

import { cn } from '@simplywallst/ui-core/next';

import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';

const giftCardImg = getCloudflareImageUrl({
  src: getStaticUrl('/gift-card-dark.png'),
  quality: 100,
});

export const GiftCard = () => {
  const [isImgLoaded, setIsImgLoaded] = useState(false);

  const className = {
    img: cn([
      'h-auto',
      'object-scale-down',
      'bg-legacy-phantom',
      'transition-opacity',
      'transition-colors',
      'animate-pulse',
      isImgLoaded ? 'opacity-100' : 'opacity-0',
    ]),
  };

  return (
    <div className="relative">
      {!giftCardImg ? (
        <div className="bones h-[180px] w-[284px]" />
      ) : (
        <>
          <img
            width={284}
            src={giftCardImg}
            alt="Gift card"
            className={className.img}
            onLoad={() => setIsImgLoaded(true)}
          />
          {isImgLoaded && (
            <div
              className="absolute left-0 h-9 w-[356px] blur-[38px]"
              style={{
                background:
                  'linear-gradient(180deg, rgba(240, 183, 165, 0.2) 0%, rgba(122, 124, 161, 0.2) 55.28%)',
              }}
            />
          )}
        </>
      )}
    </div>
  );
};
